import { render, staticRenderFns } from "./WidgetFormItem.vue?vue&type=template&id=2c29cfeb&scoped=true&"
import script from "./WidgetFormItem.vue?vue&type=script&lang=js&"
export * from "./WidgetFormItem.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFormItem.vue?vue&type=style&index=0&id=2c29cfeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29cfeb",
  null
  
)

export default component.exports